import { I18n } from '@lingui/core';
import { Genre, Instrument, Sfx, Tag, Maybe } from 'types/generated/graphql';
import { Attribute } from 'types/attributes';
import { AttributeKind } from 'types/attributes';
import { isFoundInEnum } from 'utils/isFoundInEnum';

const isCodeInEnum = ({
    code,
    validEnums,
}: {
    code: string;
    validEnums: Record<string, string>[];
}) => validEnums.some((e) => isFoundInEnum(code, e));

export const mapToAttribute = ({
    item,
    kind,
    validEnums,
    i18n,
}: {
    item: Maybe<string | Genre | Instrument | Sfx | Tag>;
    kind: AttributeKind;
    validEnums: Record<string, string>[];
    i18n: I18n;
}): Attribute | null => {
    if (!item) return null;

    const isString = typeof item === 'string';
    const code = isString ? item : item.code;

    const shouldWhitelist =
        kind === AttributeKind.Instrument ||
        kind === AttributeKind.Genre ||
        kind === AttributeKind.Sfx;

    if (!code || (shouldWhitelist && !isCodeInEnum({ code, validEnums }))) {
        return null;
    }

    return {
        kind,
        code,
        displayName: isString ? item : i18n._(code),
    };
};
